export default {"src":"/_next/static/media/google-review.16e9e2b3.svg","height":56,"width":111,"blurWidth":0,"blurHeight":0};